import { useCallback, useEffect, useState } from 'react';
import {
  isNotificationSupported,
  getNotificationPreference,
  setNotificationPreference,
  getNotificationPermission,
  requestNotificationPermission,
} from '../utils/jobNotifications';

// ステータスバーと生成キューウィンドウの両方にトグルを出すため、
// 片方を切り替えたらもう片方の表示も即同期するためのイベント名。
const PREF_EVENT = 'job-notification-pref-changed';

/**
 * ジョブ完了ブラウザ通知の ON/OFF トグル用フック。
 * 複数箇所に同時表示されても状態がズレないよう、変更を window イベントで
 * ブロードキャストして各インスタンスを同期する。
 */
export function useJobNotificationToggle() {
  const supported = isNotificationSupported();
  const [enabled, setEnabled] = useState(getNotificationPreference);

  useEffect(() => {
    const handler = () => setEnabled(getNotificationPreference());
    window.addEventListener(PREF_EVENT, handler);
    return () => window.removeEventListener(PREF_EVENT, handler);
  }, []);

  const apply = useCallback((next: boolean) => {
    setNotificationPreference(next);
    setEnabled(next);
    window.dispatchEvent(new Event(PREF_EVENT));
  }, []);

  const toggle = useCallback(async () => {
    if (getNotificationPreference()) {
      apply(false);
      return;
    }
    // ON にするタイミング（ユーザー操作起点）で許可をリクエスト
    const granted = await requestNotificationPermission();
    if (!granted) {
      apply(false);
      if (getNotificationPermission() === 'denied') {
        window.alert('ブラウザの設定で通知がブロックされています。サイトの通知を許可してから再度お試しください。');
      }
      return;
    }
    apply(true);
  }, [apply]);

  return { supported, enabled, toggle };
}
